module.exports = __webpack_public_path__ + "static/seller4.8494fc26.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/seller4.gif
// module id = 3203
// module chunks = 21364751940522